import React from "react";
import { useHistory } from "react-router-dom";
import { FaChevronRight, FaCalendar } from "react-icons/fa";
import { BsBoxArrowLeft, BsBoxArrowRight } from "react-icons/bs";

const ScheduleAbsence = ({ schedule }) => {
  const History = useHistory();

  if (!schedule) return null

  return (
    <>
      <div className="d-flex align-items-center border-bottom pb-2">
        <div>
          <FaCalendar size={20} color="#2f83ba" />
        </div>
        <div className="ps-2">
          <div className="fw-bold">
            {schedule?.date}
          </div>
        </div>
      </div>
      {schedule?.report === null ? (
        <div
          className="d-flex justify-content-between pb-2 pt-2 border-bottom"
          onClick={() =>
            History.push({
              pathname: '/clockin',
              state: {
                schedule_at: schedule?.date
              }
            })}
        >
          <div>
            <BsBoxArrowRight size={20} color="#2f83ba" />
          </div>
          <div>
            <span className="ps-2 fw-bold">Clock In</span>
          </div>
          <div>
            <FaChevronRight size={15} color="#2f83ba" />
          </div>
        </div>
      ): (
        <div className="d-flex justify-content-between pb-2 pt-2 border-bottom" onClick={() =>
          History.push({
            pathname: "/clockout",
            state: {
              report_id: schedule?.report?.id,
            },
          })}
        >
          <div>
            <BsBoxArrowLeft size={20} color="#2f83ba" />
          </div>
          <div>
            <span className="ps-2 fw-bold">Clock Out</span>
          </div>
          <div>
            <FaChevronRight size={15} color="#2f83ba" />
          </div>
        </div>
      )}
    </>
  )
}

export default ScheduleAbsence;
